import * as React from 'react';

import * as styles from './styles.css';
import { useApplicationContext } from '../../../common/containers/ApplicationContext';
import { BreadcrumbsContainer } from '../../../common/containers/BreadcrumbsContainer';
import { SeoTabsLinksContainer } from '../../../common/containers/SeoTabsLinksContainer';
import { JournalHighlightsContainer } from '../JournalHighlightsContainer';
import { SeoCrossLinksContainer } from '../SeoCrossLinks/SeoCrossLinksContainer';
import { SeoMarkedListContainer } from '../SeoMarkedList/SeoMarkedListContainer';

interface IListingMobileSeoSectionContainerProps {
  onBreadcrumbClick(): void;
}

export const ListingMobileSeoSectionContainer = ({ onBreadcrumbClick }: IListingMobileSeoSectionContainerProps) => {
  const { config } = useApplicationContext();
  const isSeoEnabled = config.get<boolean>('dailyrent.seo.Enabled');

  if (!isSeoEnabled) {
    return null;
  }

  return (
    <div className={styles['root']}>
      <BreadcrumbsContainer onBreadcrumbClick={onBreadcrumbClick} />
      <JournalHighlightsContainer />
      <SeoTabsLinksContainer />
      <SeoCrossLinksContainer />
      <SeoMarkedListContainer />
    </div>
  );
};

ListingMobileSeoSectionContainer.displayName = 'ListingMobileSeoSectionContainer';
